import { getTime, UTCDate } from '@/utils/dates';
import { TransactionView } from '../../../types/entity-types';
import { LastPaidCardConfig } from '../components/invoice-drawer/invoice-drawer-content-body';

type GetLastPaidCardConfigProps = {
  suggestedBeneficiaryId?: string;
  transactions: TransactionView[];
};

export const getLastPaidCardConfig = ({
  suggestedBeneficiaryId,
  transactions,
}: GetLastPaidCardConfigProps): LastPaidCardConfig => {
  if (!suggestedBeneficiaryId) {
    return {
      isVisible: false,
    };
  }

  const transactionsWithBeneficiary = transactions.filter((t) => t.beneficiaryId === suggestedBeneficiaryId);
  const sortedNewestToOldest = transactionsWithBeneficiary.sort(
    (a, b) => getTime(new UTCDate(b.fspDate)) - getTime(new UTCDate(a.fspDate)),
  );

  if (sortedNewestToOldest.length === 0) {
    return {
      isVisible: false,
    };
  }

  const mostRecentTransaction = sortedNewestToOldest[0];

  return {
    isVisible: true,
    lastPaidDate: mostRecentTransaction.fspDate,
    amount: mostRecentTransaction.amount,
    currency: mostRecentTransaction.currency,
  };
};
